import { useState, useEffect } from "react";
import { ArrowRight, Package } from "lucide-react";
import { useNavigate } from "react-router-dom";

const API_URL = "";

export const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/api/products?limit=4`)
      .then((r) => r.json())
      .then((data) => setProducts(Array.isArray(data) ? data.slice(0, 4) : []))
      .catch(() => setProducts([]));
  }, []);

  if (products.length === 0) return null;

  return (
    <section className="py-20 sm:py-28 bg-slate-50" data-testid="featured-products-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-14">
          <div className="max-w-xl">
            <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wide">
              Prodotti in Vetrina
            </span>
            <h2
              className="mt-3 text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight"
              style={{ fontFamily: "Outfit, sans-serif" }}
              data-testid="featured-products-title"
            >
              I migliori prodotti dei<br />nostri partner
            </h2>
            <p className="mt-4 text-slate-500 text-base sm:text-lg">
              Pannelli, inverter e batterie selezionati dai migliori produttori per garantirti qualita e affidabilita.
            </p>
          </div>
          <button
            onClick={() => navigate("/prodotti")}
            className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-600 hover:text-emerald-700 whitespace-nowrap self-start sm:self-auto"
            data-testid="view-all-products-link"
          >
            Vedi Tutti i Prodotti
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {products.map((product, i) => (
            <button
              key={product.id || i}
              onClick={() =>
                navigate(`/prodotti/${product.slug || product.id}`)
              }
              className="group text-left bg-white rounded-2xl border border-slate-100 overflow-hidden hover:border-emerald-400/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer"
              data-testid={`featured-product-${i}`}
            >
              <div className="h-36 bg-slate-50 overflow-hidden flex items-center justify-center">
                {product.image_url ? (
                  <img
                    src={
                      product.image_url.startsWith("http")
                        ? product.image_url
                        : `${API_URL}${product.image_url}`
                    }
                    alt={product.name}
                    className="w-full h-full object-contain p-3 group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <Package className="w-10 h-10 text-slate-300" />
                  </div>
                )}
              </div>
              <div className="p-4">
                {product.category && (
                  <span className="text-[10px] font-bold text-emerald-600 uppercase tracking-wider">
                    {product.category}
                  </span>
                )}
                <h3
                  className="mt-0.5 text-sm font-bold text-slate-900 line-clamp-2"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {product.name}
                </h3>
                {product.brand && (
                  <p className="mt-1 text-xs text-slate-400">{product.brand}</p>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
